import { Player } from '../assets/data'
import { Link } from 'react-router-dom'
interface PlayerCardProps {
  player: Player
}
export const PlayerPreview = ({ player }: PlayerCardProps) => {
  return (
    <div className="player-preview" title={player.name}>
      <Link to={`/players/${player.slug}`}>
        <img src={player.image} alt={player.name} />
      </Link>
    </div>
  )
}
